/** @jsx jsx */
import { jsx } from '@emotion/react';
import { useContext } from 'react';
import { WorkspaceActionCreator } from '/hooks/useWorkspaceState';
import { WorkspaceContext } from '/views/workspace/workspaceContext';
import { PropertyCheckBox } from 'components/dropdowns/propertyCheckBox';

export const BooleanSelector = ({
	cardIndex,
	widgetConfiguration,
	propertyName,
	label,
	...rest
}) => {
	const { dispatch } = useContext(WorkspaceContext);
	const value = !!widgetConfiguration?.[propertyName];

	const toggleProperty = () => {
		const configuration = JSON.parse(JSON.stringify(widgetConfiguration));
		configuration[propertyName] = !value;
		dispatch(WorkspaceActionCreator.configuration(cardIndex, configuration));
	};

	return (
		<PropertyCheckBox text={label} onChange={toggleProperty} checked={value} {...rest} />
	);
};
